import React, { Component } from "react";
import {Modal, Card, Form, Button, Row, Col, Table, Alert, Tab, Tabs, InputGroup, OverlayTrigger, Tooltip, ListGroup, FormLabel, CardBody} from "react-bootstrap";
import CreatableSelect from 'react-select/creatable';
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { formatarValor, formatarValorAPI } from '../../common/utils';
import AsyncSelect from 'react-select/async';
import Paginacao from '../../common/pagination';
import { FaEdit, FaTrash, FaArrowUp, FaArrowDown } from "react-icons/fa";
import '../ProgramasV2/ProgramasEdit.module.css';

class AcoesPrograma extends Component {
    constructor(props) {
        super(props);
        this.state = {
            acoes: [],
            acaoSelecionada: [{nome: "", ordem: ''}],
            programa_id: this.props.programa_id,
            erroLoadRegistro: '',
            loading: false,
            page_numb: this.props.page_numb || 1,
            page_limit: this.props.page_limit || 10
        }
    }

    componentDidMount() {
        this.carregarAcoesPrograma();
    }

    carregarAcoesPrograma = async () => {
        if (this.state.programa_id) {
            await api.get(`/programas/acoes/?programa_id=${this.state.programa_id}&status=1&page=${this.state.page_numb}&page_limit=${this.state.page_limit}`)
            .then(response => {
                this.setState({
                    acoes: {
                        ...response.data,
                        results:response.data.results.map(acao => ({
                            id: acao.id,
                            nome: acao.nome,
                            ordem: acao.ordem
                        }))
                    }
                });
            })
            .catch(error => {
                console.error('Erro ao carregar acoes:', error);
                
                let erro_msg = 'Erro ao carregar acoes do programa, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadRegistro: erro_msg,
                })
            });
        }
    }

    handleChangeAcao = (e, campo) => {
        const { name, value } = e.target;
        this.setState({ acaoSelecionada: { ...this.state.acaoSelecionada, [name]: value } });
    }

    moverAcao = (index, direcao) => {
        let novosAcoes = [...this.state.acoes.results];
        let acaoMovida = { ...novosAcoes[index] };
    
        if (direcao === 'up' && index > 0) {
            // Troca a etapa atual com a anterior
            novosAcoes[index] = novosAcoes[index - 1];
            novosAcoes[index - 1] = acaoMovida;
            // Atualiza a ordem (index baseado em 1 para a ordem)
            novosAcoes[index].ordem = index + 1;
            novosAcoes[index - 1].ordem = index;
        } else if (direcao === 'down' && index < novosAcoes.length - 1) {
            // Troca a etapa atual com a seguinte
            novosAcoes[index] = novosAcoes[index + 1];
            novosAcoes[index + 1] = acaoMovida;
            // Atualiza a ordem
            novosAcoes[index].ordem = index + 1;
            novosAcoes[index + 1].ordem = index + 2;
        }
    
        // Atualiza o estado
        this.setState({ acoes: { ...this.state.acoes, results: novosAcoes } }, () => {
            // Salva a etapa movida com a nova ordem
            this.handleSalvarAcao(index + (direcao === 'down' ? 1 : -1));
            // Salva a etapa que foi substituída pela movida, para atualizar sua ordem
            this.handleSalvarAcao(index);
        });
    };

    handleSalvarAcao = async (index = null) => {
        const acao = index !== null ? this.state.acoes.results[index] : this.state.acaoSelecionada;
        let url = '';
        let metodo = '';

        if(index !== null){
            url = `/programas/acoes/${this.state.acoes.results[index].id}/`;    
            metodo = 'put';
        } else {
            url = acao.id ? `/programas/acoes/${acao.id}/` : '/programas/acoes/';
            metodo = acao.id ? 'put' : 'post';
        }

        const dadosAcao = {
            nome: acao.nome,
            programa_id: this.state.programa_id
        };

        if(index){
            dadosAcao['ordem'] = index + 1;
        } else {
            dadosAcao['ordem'] = acao.ordem || this.state.acoes.results.length + 1;
        }

        api({
            method: metodo,
            url: url,
            data: dadosAcao,
        })
        .then(response => {
            if(index == null){
                const MySwal = withReactContent(Swal)
                const textSwal = (this.state.acaoSelecionada.id) ? 'Ação atualizada com sucesso' : 'Ação cadastrada com sucesso';

                MySwal.fire({
                    title: <p>{textSwal}</p>,
                    icon: 'success',
                    showCloseButton: true,
                })

                this.carregarAcoesPrograma();
                this.handleCloseModalAcoes();
            }
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar a ação, verifique os campos e tente novamente';         
            let content = '';   

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key == 'produto_id') {
                        content += `<br>&bull; Produto: ${value}`;
                    }
                    if(key == 'valor') {
                        content += `<br>&bull; Valor: ${value}`;
                    }
                }
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content,
            })
        });
    }

    removerAcao = (acao) => {
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Remover ação?',
            text: "Tem certeza que deseja remover a ação #" + acao.nome + "?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                if (acao.id) {
                    api({
                        method: 'delete',
                        url: `/programas/acoes/${acao.id}/`,
                    })
                    .then(response => {
                                              
                        const MySwal = withReactContent(Swal)
                        const textSwal = 'Ação removida com sucesso';

                        MySwal.fire({
                            title: <p>{textSwal}</p>,
                            icon: 'success',
                            showCloseButton: true,
                        })

                        this.carregarAcoesPrograma();
                    })
                    .catch(error => {
                        let erro_msg = 'Erro ao remover a ação, tente novamente';            

                        if(error.response && error.response.status === 500){
                            erro_msg = 'Servidor indisponível no momento';
                        }
                        else if(error.response && error.response.status === 400){
                            const campos = error.response.data;       
                            
                        }

                        const MySwal = withReactContent(Swal)
                        MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: <p>{erro_msg}</p>,
                        })
                    });
                }
            }
        });
    };

    handleShowModalAcoes = (acao = []) => {
        this.setState({ showModalAcoes: true, acaoSelecionada: acao });
    }

    handleCloseModalAcoes = () => {
        this.setState({ showModalAcoes: false, acaoSelecionada: [] });
    }

    onClickPaginaAcoes = (num_page) => {
        this.setState({
            loading: true,
            page_numb: num_page
        }, () => {
            this.carregarAcoesPrograma(num_page)
        });
    };


    render() {
        return (
            <>
            <Card className="cardDestaque mt-4">
                <Card.Body>                   
                    <Row className="align-items-center mb-3">
                        <Col sm={6} lg={6}>
                            <h6><strong>Ações do Programa</strong></h6>
                        </Col>
                        <Col sm={6} xs={6} className="text-end">                       
                            <Button type="button" variant="success" className="btn-sm mt-3" disabled={this.state.loading} onClick={() => this.handleShowModalAcoes()}>
                                {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : 'Adicionar Ação'}                                       
                            </Button>
                        </Col>
                    </Row>
                    {('results' in this.state.acoes && this.state.acoes.results.length > 0) ? (
                        <Row>
                            <Col sm={12} lg={12}>
                                <Table responsive className="custom-table">
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Título</th>
                                            <th>Ordem</th>  
                                            <th>Opções</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.acoes.results.map((acao, index) => ( 
                                            <tr key={index}>
                                                <td className="bg-id">#{acao.id}</td>
                                                <td className="td-border">{acao.nome}</td>
                                                <td className="td-border">{acao.ordem}
                                                    {acao.id && index > 0 && (
                                                        <Button variant="outline-primary" className="btn-sm me-2" onClick={() => this.moverAcao(index, 'up')}><FaArrowUp /></Button>
                                                    )}
                                                    {acao.id && index < this.state.acoes.results.length - 1 && (
                                                        <Button variant="outline-primary" className="btn-sm" onClick={() => this.moverAcao(index, 'down')}><FaArrowDown /></Button>
                                                    )}
                                                </td>
                                                <td>
                                                    <Button variant="secondary" size="sm" className="me-2" onClick={() => this.handleShowModalAcoes(acao)}>
                                                        <FaEdit /> Editar
                                                    </Button>  
                                                    <Button variant="danger" size="sm" className="me-2" onClick={() => this.removerAcao(acao)}>
                                                        <FaTrash /> Remover
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                                    {'results' in this.state.acoes && this.state.acoes.results.length > 0 && (
                                        <Paginacao dados={this.state.acoes} limit={this.state.page_limit} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPaginaAcoes} />
                                    )}
                            </Col>
                        </Row>   
                    ) : (
                        <p>Nenhuma ação cadastrada até o momento</p>
                    )}
                            
                </Card.Body>                
            </Card>

            <Modal show={this.state.showModalAcoes} onHide={this.handleCloseModalAcoes}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {this.state.acaoSelecionada.id ? 'Editar Ação #' + this.state.acaoSelecionada.id : 'Adicionar Ação'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Row>                                                
                            <Col sm={6} xs={12}>
                                <Form.Group>
                                    <Form.Label>Título</Form.Label>   
                                    <Form.Control 
                                        type="text"                                                             
                                        name="nome"
                                        value={this.state.acaoSelecionada.nome} 
                                        onChange={(e) => this.handleChangeAcao(e, "nome")}
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={6} xs={12}>
                                <Form.Group>
                                    <Form.Label>Ordem</Form.Label>   
                                    <Form.Control 
                                        type="number"                                                             
                                        name="ordem"
                                        value={this.state.acaoSelecionada.ordem} 
                                        onChange={(e) => this.handleChangeAcao(e, "ordem")}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.handleCloseModalAcoes}>
                        Fechar
                    </Button>
                    <Button variant="primary" onClick={() => this.handleSalvarAcao()}>
                        Salvar
                    </Button>
                </Modal.Footer>
            </Modal>
            </>
        );
    }
}

export default AcoesPrograma;

